module.exports = "https://www.gc-qa.gnp.com.mx/aa62bdbf758a0dfb709688105dbbf238.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mastercard-card.png
// module id = 1851
// module chunks = 0